import * as Sentry from "@sentry/react";
import type { ReactNode, FC } from "react";
import { getEnvironment } from "@/lib/environment";
import packageJson from "../../package.json";

Sentry.init({
  dsn: "https://9b42ce427dc7cbb46552a18114e35a97@o4508970545184768.ingest.de.sentry.io/4508970548265040",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  environment: getEnvironment(),
  release: `${packageJson.name}@${packageJson.version}`,
  enabled: import.meta.env.PROD,
});

export const SentryProvider: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <Sentry.ErrorBoundary fallback={<div>An error has occurred</div>}>
      {children}
    </Sentry.ErrorBoundary>
  );
};
